import { useParams } from "react-router-dom";

const useIsMasterDataset = () => {
  const { datasetId } = useParams();
  return datasetId === "00000000-0000-0000-0000-000000000000";
};

export default useIsMasterDataset;
